import PropTypes from 'prop-types'
import styled from 'styled-components'

import colors from 'components/utils/colors'

import Badge from 'components/Shared/Badge/Index'
import ColorCircle from 'components/Shared/ColorCircle/Index'

import OtherItems from './OtherItems'

const StyledMultipleFilters = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const StyledTitle = styled.span`
  margin-right: 8px;
`

const StyledItems = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const StyledItem = styled.div`
  font-size: 10px;
  display: flex;
  align-items: center;
`

const FilterLabel = styled.div`
`

/* eslint-disable react/prop-types */
const FilterItem = ({ color, value }) => {
  return (
    <StyledItem data-test='multiple-filters-item'>
      {color && <ColorCircle color={color} />}
      <FilterLabel>{value}</FilterLabel>
    </StyledItem>
  )
}

const MultipleFilters = ({
  items, onClear, title, onContractorClick,
  clearTooltip, tooltipId, maxDisplayItems, dataTest,
}) => {
  if (!items?.length) {
    return null
  }

  return (
    <StyledMultipleFilters data-test={`${dataTest || title}-multiple-filters`}>
      <Badge
        onDelete={onClear}
        color={colors.secondary95}
        margin='0'
        deleteTooltip={clearTooltip}
        deleteTooltipId={tooltipId}
      >
        <StyledTitle data-test='multiple-filters-title'>{title}:</StyledTitle>
        <StyledItems>
          {items.slice(0, maxDisplayItems).map(multipleFilter => {
            return (
              <FilterItem
                key={multipleFilter.value}
                color={multipleFilter.bgColor}
                value={multipleFilter.value}
              />
            )
          })}

          <OtherItems
            itemsCount={items.length}
            onClick={onContractorClick}
            maxDisplayItems={maxDisplayItems}
          />
        </StyledItems>
      </Badge>
    </StyledMultipleFilters>
  )
}

MultipleFilters.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
  onClear: PropTypes.func,
  clearTooltip: PropTypes.string,
  tooltipId: PropTypes.string,
  maxDisplayItems: PropTypes.number,
  onContractorClick: PropTypes.func,
  /** stable test id, defaults to the localized title */
  dataTest: PropTypes.string,
}

export default MultipleFilters
